import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    radio: {
      color: theme.palette.primary.main,
      '&:hover': {
        color: theme.palette.primary.main,
      },
      '&.Mui-checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          color: theme.palette.primary.main,
        },
      },
    },
    error: {
      color: theme.palette.error.main,
      '&:hover': {
        color: theme.palette.error.main,
      },
    },
  })
);
